import { Grid, useTheme } from "@mui/material";
import React from "react";
import { getAmountWithSign } from "../../helper-functions/CardHelpers";
import loyaltyImage from "./asset/loyalty.png";
import wallet from "./asset/newWallet.png";
import orderImage from "./asset/order.png";

import ProfileStatistics from "../profile/ProfileStatistics";

const UserDashBoard = ({ data, configData, isLoading }) => {
  const theme = useTheme();
  return (
    <Grid
      container
      item
      md={8}
      alignItems="center"
      spacing={2}
      sx={{
        paddingTop: { xs: "10px", sm: "15px", md: "40px" },
        '& .MuiGrid-item': {
          paddingLeft: { xs: '8px', sm: '12px', md: '20px' },
          paddingTop: { xs: '8px', sm: '12px', md: '20px' }
        }
      }}
      xs={12}
      sm={12}
    >
      <Grid item xs={6} sm={6} md={3}>
        <ProfileStatistics
          isLoading={isLoading}
          value={data?.member_since_days}
          title="Days Since Joining"
          image={data?.image}
          pathname="profile-settings"
        />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <ProfileStatistics
          isLoading={isLoading}
          value={getAmountWithSign(data?.wallet_balance)}
          title="Amount in Wallet"
          image={wallet}
          pathname="wallet"
        />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <ProfileStatistics
          isLoading={isLoading}
          value={data?.order_count}
          title="Total Orders"
          image={orderImage}
          pathname="my-orders"
        />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <ProfileStatistics
          isLoading={isLoading}
          value={data?.loyalty_point}
          title="loyalty points"
          image={loyaltyImage}
          pathname="loyalty-points"
        />
      </Grid>
    </Grid>
  );
};

export default UserDashBoard;
